import { ActivityLedgerFilters, ActivityLedgerRow } from '../../api/incomeExpenseApi';
import { downloadExcel, sanitizeExportFilename } from '../../utils/excelExport';

const formatExportDate = (value: string) => new Date(value).toLocaleDateString('vi-VN');

const formatExportDateTime = (value: string) => new Date(value).toLocaleString('vi-VN');

export function buildActivityLedgerExportHeaders(kind: 'revenue' | 'expenditure'): string[] {
  const categoryLabel = kind === 'revenue' ? 'Loại phiếu thu' : 'Loại phiếu chi';
  const actualDateLabel = kind === 'revenue' ? 'Ngày thực thu' : 'Ngày thực chi';
  return [
    'Mã căn hộ',
    'Tên căn hộ',
    categoryLabel,
    'Tên phiếu',
    'Lý do',
    'Số bút toán',
    actualDateLabel,
    'Ngày tạo',
    'Người tạo',
    'Hình thức thanh toán',
    'Tiền mặt',
    'Chuyển khoản',
    'Số tiền',
  ];
}

export function mapActivityLedgerRowsToExportData(rows: ActivityLedgerRow[]): (string | number)[][] {
  return rows.map((row) => [
    row.apartmentCode || '',
    row.apartmentName || '',
    row.categoryName,
    row.voucherName || row.voucherCode || '',
    row.reason || '',
    row.voucherCode || '',
    formatExportDate(row.actualDate),
    formatExportDateTime(row.createdAt),
    row.performerName || '',
    row.paymentMethodLabel || '—',
    row.cashAmount ?? 0,
    row.transferAmount ?? 0,
    row.amount,
  ]);
}

export function exportActivityLedgerReport(params: {
  kind: 'revenue' | 'expenditure';
  buildingName: string;
  filters: ActivityLedgerFilters;
  rows: ActivityLedgerRow[];
  totalAmount: number;
  totalCashAmount?: number;
  totalTransferAmount?: number;
}): void {
  const { kind, buildingName, filters, rows, totalAmount, totalCashAmount, totalTransferAmount } =
    params;
  const headers = buildActivityLedgerExportHeaders(kind);
  const dataRows = mapActivityLedgerRowsToExportData(rows);
  const cashTotal =
    totalCashAmount ??
    rows.reduce((sum, row) => sum + (row.cashAmount ?? 0), 0);
  const transferTotal =
    totalTransferAmount ??
    rows.reduce((sum, row) => sum + (row.transferAmount ?? 0), 0);
  const footerPad = ['', '', '', '', '', '', '', '', ''];
  dataRows.push([...footerPad, 'Tổng tiền mặt', cashTotal, 0, '']);
  dataRows.push([...footerPad, 'Tổng chuyển khoản', 0, transferTotal, '']);
  dataRows.push([...footerPad, 'Tổng cộng', cashTotal, transferTotal, totalAmount]);

  const fromPart = filters.dateFrom ? filters.dateFrom : 'all';
  const toPart = filters.dateTo ? filters.dateTo : 'all';
  const prefix = kind === 'revenue' ? 'hoat-dong-thu' : 'hoat-dong-chi';
  const filename = `${sanitizeExportFilename(`${prefix}_${buildingName}_${fromPart}_${toPart}`)}.xlsx`;
  const sheetName = kind === 'revenue' ? 'Hoạt động thu' : 'Hoạt động chi';
  downloadExcel(sheetName, headers, dataRows, filename);
}
